export const parseUrlSearch = (search: string) => {
  const urlSearchParams = new URLSearchParams(search);
  return Object.fromEntries(urlSearchParams.entries());
};
